<template>
  <div>
    <transition name="expand">
      <div v-if="isError" class="App-confirm__event-card--error">
        <error-component></error-component>
      </div>
    </transition>

    <transition name="expand">
      <div v-if="!isFormLoading && !isError">
        <simple-mode
          v-if="mode === 'simple'"
          :meeting="meeting"
          :display-options="displayOptions"
          :is-attending="isAttending"
          :view="view"
          @openAboutModal="showModal = true"
        />

        <default-mode
          v-else
          :meeting="meeting"
          :voter="voter"
          :display-options="displayOptions"
          :is-attending="isAttending"
          :view="view"
          @openAboutModal="showModal = true"
        />
      </div>
    </transition>

    <about-modal
      :about-text="meeting.meetingAbout"
      v-show="showModal"
      @close-modal="showModal = false"
    />

    <rsvp-modal
      v-show="showRsvpModal"
      :home-display-options="homeDisplayOptions"
      :is-voting-disabled="isVotingDisabled"
      :meeting="meeting"
      @close-modal="setShowRsvpModal(false)"
    />

    <revoke-modal
      :unit="voter.unit"
      :address="voter.address"
      :revocation-deadline="meeting.revocation_deadline_date"
      :timezone="meeting.meeting_timezone"
      :short-code="meeting.shortCode"
      v-show="showRevokeModal"
      @close-modal="setShowRevokeModal(false)"
    />
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import ErrorComponent from './Error.vue';
import MeetingAbout from './MeetingAbout.vue';
import EventDetails from './EventDetails.vue';
import StartProxy from './StartProxy.vue';
import AboutModal from './AboutModal.vue';
import RsvpModal from './RsvpModal';
import RevokeModal from './RevokeModal/RevokeModal';

import DefaultMode from './Mode/Default';
import SimpleMode from './Mode/Simple';

import _ from 'lodash';

export default {
  name: 'Home',
  components: {
    ErrorComponent,
    MeetingAbout,
    EventDetails,
    StartProxy,
    AboutModal,
    RsvpModal,
    RevokeModal,
    DefaultMode,
    SimpleMode
  },
  computed: {
    ...mapGetters({
      meeting: 'meeting/meeting',
      loading: 'meeting/loading',
      error: 'error',
      displayOptions: 'displayOptions',
      showRsvpModal: 'showRsvpModal',
      showRevokeModal: 'showRevokeModal',
      voter: 'voter'
    }),
    ...mapGetters('voter', ['voter', 'isAttending', 'isVotingDisabled']),
    homeDisplayOptions() {
      return _.get(this.displayOptions, 'home', {});
    },
    isFormLoading() {
      // check if meeting data is loaded
      return this.loading;
    },
    isError() {
      return Boolean(this.error.message);
    },
    view() {
      if (this.$route.query.hasOwnProperty('view')) {
        return this.$route.query.view;
      }
      return '';
    },
    mode() {
      // Show meeting package by default
      return _.get(this.displayOptions, 'home.mode', false);
    }
  },
  mounted() {
    componentHandler.upgradeAllRegistered();
  },
  methods: {
    ...mapActions(['setShowRsvpModal', 'setShowRevokeModal'])
  },
  data() {
    return {
      showModal: false
    };
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue